export default __webpack_public_path__ + "static/media/lock-chart-light.2f4030aa.svg";